import { client, unwrap } from './client';

export interface CustomerSummary {
  id: string;
  name: string;
  email: string;
  companyName: string | null;
  billingPlan: string;
  status: string;
}

export async function requestMagicLink(email: string): Promise<void> {
  await client.post('/inference-customer/auth/request-link', { email });
}

export async function verifyMagicLink(
  token: string
): Promise<{ token: string; customer: CustomerSummary }> {
  return unwrap(
    client.post('/inference-customer/auth/verify', { token })
  );
}
